import axios from "axios";
import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../rootReducer";
import axiosInstance from "../../../utils/axiosConfig";


export const setDocumentPending = createAsyncThunk(
  "documentUpdate/setDocumentPending",
  async (documentId: number | undefined, { getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;

      // ✅ Usa el ID pasado, o cae en documentShow.document.id
      const finalDocumentId =
        documentId ?? state.documentShow.document?.id;

      if (!finalDocumentId) {
        throw new Error("No se pudo determinar el ID del documento");
      }

      const response = await axiosInstance.post(`${api.baseURL}document/activate`, {
        document: finalDocumentId,
        user: state.userAuthentication.user?.id,
      });

      return response.data as Document;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error);
    }
  }
);
